import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { VehicleLiveTracking } from './interface';
// import { Store } from './store';
import { SharedService } from './../../Services/shared.service';
import { StorageService } from 'src/app/Services/storage.service';

export class Store<T> {

  private state$: BehaviorSubject<VehicleLiveTracking[]>;
  protected constructor(initialState: VehicleLiveTracking[] = []) {
    this.state$ = new BehaviorSubject(initialState);
    // console.log("this.state$-------->", this.state$)
  }
  getValue(): VehicleLiveTracking[] {
    return this.state$.getValue();
  }
  getState(): Observable<VehicleLiveTracking[]> {
    return this.state$.asObservable();
  }
  setState(item: VehicleLiveTracking[]): void {
    this.state$.next(item);
  }
}

@Injectable()

export class VehicleLiveTrackService extends Store<VehicleLiveTracking[]> {
  constructor(
    private share: SharedService,
    public storage: StorageService,
  ) {
    super();
  }
  addVehicleInfo(newItem: any,): void {
    // console.log("newItem------->", newItem,)
    try {
      const data = this.getValue();
      // console.log("data------->", data)
      const newData = (typeof newItem == 'string') ? JSON.parse(newItem) : newItem;
      // console.log("newData===============?", newData)

      if (data.filter(itm => itm.reg == newData.reg).length > 0) {
        const returnData: any = data.map((item: any) => {
          const currnentTMS = new Date().getTime();

          const restrictedDays = new Date().setDate(new Date().getDate() - 2);
          const restrictedDatetime = new Date(restrictedDays).setHours(0, 0, 0, 0);
          const restrictedTimestamp = new Date(restrictedDatetime).getTime();
          if (item.reg == newData.reg) {
            item.serverts = newData.serverts;
            item.near = newData.near;
            item.lat = newData.lat;
            item.lng = newData.lng;
            item.imei = newData.imei;
            item.spd = newData.spd;
            item.gpsts = newData.gpsts;
            item.ac = newData.ac;
          }
          // if (item.length == 1) {
            return item;
          // }
          /*  if((restrictedTimestamp<= (item.gpsts.length>10? item.gpsts: item.gpsts *1000) )){
           } */
        });
        // console.log("returnData===============?", returnData,)
        // if (this.storage.get('storedData') == undefined) {
        //   console.log("returnData.filter(item => !!item)")
        //   this.storage.setData({ 'storedData': returnData.filter(item => !!item) })
        // } else {
        //   const storedData = this.storage.get('storedData');
        //   console.log("storedData---------->", storedData)
        // }
        this.share._subject.next({
          type: 'socketData',
          data: returnData.filter(item => !!item)
        });
        this.setState(returnData.filter(item => !!item));
      } else {
        // this.storage.setData({ storedData: data.data })
        this.setState([...this.getValue(), newData]);
      }
    } catch (error) {
      console.log('Error', error);
    }

  }
  get(): VehicleLiveTracking[] {
    return this.getValue();
  }
  listen(): Observable<VehicleLiveTracking[]> {
    return this.getState();
  }


}
